/*
 * @author       julian@zumper.com (Julian Napolitan)
 * @copyright    Copyright (c) 2025, Zumper
 */

import type { PropertyFeatures } from '@zcode/enums'
import { orFeatureVerticals } from './constants'

export const removeOrFeatureVerticals = (orFeatures: readonly PropertyFeatures[]) => {
  return orFeatures.filter((item) => !orFeatureVerticals.has(item))
}
